export const SESSION_USER_ID = 'sessionUserID';
let memoryId = '';

export const setUserId = (userId?: number): void => {
  const id = userId ? userId.toString() : '';

  memoryId = id;
  localStorage.setItem(SESSION_USER_ID, id);
};

export const getMemoryUserId = (): string => memoryId;

export const getCurrentSessionUserId = (): string | null => localStorage.getItem(SESSION_USER_ID);
